export default {"src":"/_next/static/media/stressMotivationMobile.18d596fc.svg","height":244,"width":273,"blurWidth":0,"blurHeight":0};